import {
  LayoutDashboard,
  TrendingUp,
  ClipboardList,
  Wallet,
  HeartPulse,
  Zap,
  FlaskConical,
} from 'lucide-react';
import { useAppStore } from '../../store/useAppStore';
import { SportSubNav, SubNavItem } from '../common/SportSubNav';

const MLB_NAV: SubNavItem[] = [
  { to: '/baseball/mlb/command-center', icon: LayoutDashboard, label: 'Command Center', isLive: true, isEnd: true },
  { to: '/baseball/mlb/advisor',        icon: TrendingUp,      label: 'Bet Advisor'                               },
  { to: '/baseball/mlb/bets',           icon: ClipboardList,   label: 'Bet History'                               },
  { to: '/baseball/mlb/bankroll',       icon: Wallet,          label: 'Bankroll'                                  },
  { to: '/baseball/mlb/health',         icon: HeartPulse,      label: 'Health'                                    },
  { to: '/baseball/mlb/simulator',      icon: Zap,             label: 'Simulator',  gate: 'simulator'             },
  { to: '/baseball/mlb/backtest',       icon: FlaskConical,    label: 'Backtest',   gate: 'backtesting'           },
];

export function DiamondEdgeSubNav() {
  const { games } = useAppStore();
  const liveCount = games.filter((ctx) => ctx.game.status.abstractGameState === 'Live').length;

  return <SportSubNav items={MLB_NAV} liveCount={liveCount} />;
}
